import Rest from '@/services/Rest';

/**
 * @typedef {AffiliateService}
 */
export default class AffiliateService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/affiliate'

  showForRecruitment(affiliate_id, product_id, config = {}) {
    return this.get(`/recruitment/${affiliate_id}/${product_id}`,config);
  }
}
